export default "__VITE_PUBLIC_ASSET__8d0bb90e__"